import { render, staticRenderFns } from "./CategoryTableActive.vue?vue&type=template&id=19641162&scoped=true"
import script from "./CategoryTableActive.vue?vue&type=script&lang=js"
export * from "./CategoryTableActive.vue?vue&type=script&lang=js"
import style0 from "./CategoryTableActive.vue?vue&type=style&index=0&id=19641162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19641162",
  null
  
)

export default component.exports